/* globals gtag, fbq, $ */

'use strict';

$(function () {
  $('.fund-rating-item .top[aria-controls]').click(function () {
    const expandable = $('#' + $(this).attr('aria-controls'));

    expandable.toggleClass('expanded');
    const isExpanded = expandable.hasClass('expanded');
    $(this).attr('aria-expanded', isExpanded);
    expandable.attr('aria-hidden', !isExpanded).prop('inert', !isExpanded);
    $(this).find('.icon-down-arrow').toggleClass('flip', isExpanded);
  });

  function expandDesktopContainer(expanded) {
    if ($('#fund-desktop-content-container').hasClass('expanded')) {
      if (!expanded) {
        $('#fund-desktop-content-container').removeClass('expanded');
      }
    } else {
      $('#fund-desktop-content-container').addClass('expanded');
    }
  }

  function focusDesktopContent(controller) {
    $('.desktop-controller-item').attr('aria-expanded', 'false');
    controller.attr(
      'aria-expanded',
      $('#fund-desktop-content-container').hasClass('expanded'),
    );
    $('#fund-desktop-content-container').trigger('focus');
  }

  $('#desktop-cost-controller-item').click(function () {
    if (!$('#desktop-cost-container').hasClass('show')) {
      expandDesktopContainer(true);
      $('#desktop-cost-container').addClass('show');
      $('#desktop-triangle').css('left', '17%');
    } else {
      expandDesktopContainer(false);
    }

    if ($('#desktop-result-container').hasClass('show')) {
      $('#desktop-result-container').removeClass('show');
    }

    if ($('#desktop-requirements-container').hasClass('show')) {
      $('#desktop-requirements-container').removeClass('show');
    }

    focusDesktopContent($(this));
  });

  $('#desktop-result-controller-item').click(function () {
    if ($('#desktop-cost-container').hasClass('show')) {
      $('#desktop-cost-container').removeClass('show');
    }

    if (!$('#desktop-result-container').hasClass('show')) {
      $('#desktop-result-container').addClass('show');
      expandDesktopContainer(true);
      $('#desktop-triangle').css('left', '50%');
    } else {
      expandDesktopContainer(false);
    }

    if ($('#desktop-requirements-container').hasClass('show')) {
      $('#desktop-requirements-container').removeClass('show');
    }

    focusDesktopContent($(this));
  });

  $('#desktop-requirements-controller-item').click(function () {
    if ($('#desktop-cost-container').hasClass('show')) {
      $('#desktop-cost-container').removeClass('show');
    }

    if ($('#desktop-result-container').hasClass('show')) {
      $('#desktop-result-container').removeClass('show');
    }

    if (!$('#desktop-requirements-container').hasClass('show')) {
      $('#desktop-requirements-container').addClass('show');
      expandDesktopContainer(true);
      $('#desktop-triangle').css('left', '83%');
    } else {
      expandDesktopContainer(false);
    }

    focusDesktopContent($(this));
  });

  $('.year-item button').click(function () {
    const result = $(this).closest('.result');
    const year = $(this).data('year');

    result.find('.benchmark-year-container').css('opacity', 0);
    result.find('.benchmark-' + year + 'yr').css('opacity', 1);
    result
      .find('.year-item button')
      .attr('aria-pressed', 'false')
      .removeClass('selected');
    $(this).attr('aria-pressed', 'true').addClass('selected');
    result.find('.benchmark-container').trigger('focus');
  });

  $('#download-button').click(function () {
    /* eslint-disable camelcase */
    gtag('event', 'download_clicked', {
      event_category: 'reading',
      event_label: 'Fund Page',
    });
    /* eslint-enable camelcase */
    fbq('track', 'DownloadClicked');
  });

  const riskInformation = $('.fund-risk-information');
  const riskInformationHiddenKey = 'fund-risk-information-hidden-key';

  riskInformation.find('.close-button').click(() => {
    riskInformation.hide();

    let expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + 1);

    sessionStorage.setItem(riskInformationHiddenKey, expiryDate.toString());
  });

  // Check if risk information was hidden
  const latestRiskInformationHiddenDate = sessionStorage.getItem(
    riskInformationHiddenKey,
  );

  if (
    latestRiskInformationHiddenDate === null ||
    new Date(latestRiskInformationHiddenDate) < new Date()
  ) {
    riskInformation.show();
  }
});
